import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import FeatherIcon from './FeatherIcon'; // Adjust the path according to your project structure

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    // Initialize feather icons
    const feather = require('feather-icons');
    feather.replace();
  }, []);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top sticky bg-white" id="navbar">
      <div className="container">
        <Link className="navbar-brand" >
          <img src="assets/images/logo.png" className="logo-light" alt="" height="40" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNav}
          aria-expanded={isNavOpen ? 'true' : 'false'}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggle-icon">
            <FeatherIcon icon="menu" />
          </span>
        </button>
     <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav mx-auto navbar-center mt-lg-0 mt-2">
            <li className="nav-item">
              <Link className="nav-link active" to="home" spy={true} smooth={true} offset={-80} duration={500}>Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="aboutme" spy={true} smooth={true} offset={-80} duration={500}>About Me</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="technical_background" spy={true} smooth={true} offset={-80} duration={500}>Technical Background</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="experience" spy={true} smooth={true} offset={-80} duration={500}>Experience</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="contact" spy={true} smooth={true} offset={-80} duration={500}>Contact</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
